const textCategory = (axios) => {
  return {

    get: () => axios.get('/TextCategory'),

  };
};

export default textCategory;
